import { Link } from 'react-router-dom';

const PixelButton = ({ children, variant = 'primary', href, external = false, onClick }) => {
  const baseClasses = 'pixel-btn';
  const variantClasses = variant === 'primary' ? 'pixel-btn--primary' : 'pixel-btn--secondary';
  const className = `${baseClasses} ${variantClasses}`;

  if (external) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
      >
        {children}
      </a>
    );
  }

  if (href) {
    return (
      <Link to={href} className={className}>
        {children}
      </Link>
    );
  }

  return (
    <button onClick={onClick} className={className}>
      {children}
    </button>
  );
};

export default PixelButton;